module.exports = __webpack_public_path__ + "img/house.198fde75.svg";